import { render, staticRenderFns } from "./pi-button.vue?vue&type=template&id=5a8ee336&scoped=true&"
import script from "./pi-button.vue?vue&type=script&lang=js&"
export * from "./pi-button.vue?vue&type=script&lang=js&"
import style0 from "./pi-button.vue?vue&type=style&index=0&id=5a8ee336&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ee336",
  null
  
)

export default component.exports